import React, { Component } from 'react'
import { Button } from "primereact/button";
import { InputSwitch } from "primereact/inputswitch";
import { RadioButton } from 'primereact/radiobutton';
import ClassetDropdown from "../../../classetComponents/classetDropDown";
import ClassetInputText from "../../../classetComponents/classetInputText";
import Service from "../../../services";
import { getFormFields, onChoiceChange, onDropDownChange, onTextChange, onToggleChange } from "../../../utile/formHelper";
import { baseUrlAdmin } from "../../../store/apiConstants";
import { Toast } from "primereact/toast";
import LoadingComponent from "../../loadingComponent";
import Authorizer, { PERMISSIONS } from "../../session/authorizer";
const generalSettingsformFields = require('./generalSettings.json');
const principalNames = [
    { value: 1, label: "sudha" },
    { value: 2, label: "sudharshan" },
]
const sampleOptions = [
    { value: 1, label: "1" },
    { value: 2, label: "2" },
    { value: 3, label: "3" },
    { value: 4, label: "4" },
    { value: 5, label: "5" },
]

const adjustmentRules = [
    { value: 1, label: "By Day" },
    { value: 2, label: "By Term" },
    { value: 3, label: "By Week" },
    { value: 4, label: "By Month" },
    { value: 5, label: "No Ajustment" },
    { value: 6, label: "Manual" },

]




class GeneralSettings extends Component {
    constructor(props) {
        super(props)
        this.formFields = getFormFields(generalSettingsformFields);
        this.state = {
            generalSettings: {},
            formValidations: this.formFields.formValidations,
            admissionCategories: [],
            categoryPairs: [{ from: '', to: '', midTermTransfersAllowed: false }]

        }
        this.service = new Service();

    }
    async componentDidMount() {
        await this.getAdmissionCategoryOptions()
        await this.getGeneralSettings()
    }
    getGeneralSettings = () => {
        let academicYear = localStorage.getItem('userAcademicYear')
        let url = `${baseUrlAdmin}/feeSettings?academicYear=${academicYear}`
        this.setState({
            isLoading: true
        });
        this.service.get(url, true).then(data => {
            if (data.status) {
                if (data.res.status && data?.res?.data?.feeSettings) {
                    let generalsettings = {
                        ...data?.res?.data?.feeSettings,
                        ...data?.res?.data?.feeSettings?.blockStudent,
                        ...data?.res?.data?.feeSettings?.concessionSettings,
                        ...data?.res?.data?.feeSettings.reportCards,
                        ...data?.res?.data?.feeSettings.feeReceiptSettings,
                        // Ensure payment gateway fields are included with default values
                        paymentGatewayBoth: data?.res?.data?.feeSettings?.paymentGatewayBoth || false,
                        paymentGatewayWeb: data?.res?.data?.feeSettings?.paymentGatewayWeb || false,
                        paymentGatewayMobile: data?.res?.data?.feeSettings?.paymentGatewayMobile || false
                    }
                    delete generalsettings.concessionSettings
                    delete generalsettings.blockStudent
                    delete generalsettings.reportCards
                    delete generalsettings.feeReceiptSettings


                    this.setState({
                        generalSettings: generalsettings,
                        isLoading: false,
                        categoryPairs: data?.res?.data?.feeSettings?.categoryPairs?.length > 0 ? data?.res?.data?.feeSettings?.categoryPairs : [{ from: '', to: '', midTermTransfersAllowed: false }],
                    })
                } else {
                    this.setState({
                        isLoading: false
                    })
                }
            } else {
                this.setState({
                    isLoading: false
                })
            }
        });

    }


    getAdmissionCategoryOptions = async () => {
        this.setState({ isLoading: true });
        const academicYear = localStorage.getItem('userAcademicYear');
        let url = `${baseUrlAdmin}/admission-types/active?academicYear=${academicYear}`;
        this.service.get(url, true).then((data) => {
            const options = data?.res?.data?.map((each) => {
                return {
                    label: each?.categoryName,
                    value: each?._id
                };
            });

            if (data?.status && data?.res?.data) {
                this.setState({ admissionCategories: options, isLoading: false });
            } else {
                this.setState({ isLoading: false });
                this.toast?.show({ severity: 'error', summary: 'Error', detail: 'An error occurred while getting the Admission category options', life: 3000 });
            }
        });
    };

    onSubmitGeneralSettings = () => {
        this.setState({
            isLoading: true
        });
        const AcademicYear = localStorage.getItem('userAcademicYear')
        let g = this.state.generalSettings
        let payload = {
            gstPer: g.gstPer,
            "receiptPrefix": g.receiptPrefix?.toUpperCase(),
            "authorizedSignatory": g.authorizedSignatory,
            "isLockFeeCollection": g.isLockFeeCollection,
            "isPrintTransportDetails": g.isPrintTransportDetails,
            "isTransportdetailsinFeeReceipt": g.isTransportdetailsinFeeReceipt,
            "isStudentLoginFeeCollection": g.isStudentLoginFeeCollection,
            "isPartialPayment": g.isPartialPayment,
            "isEnablePaymentGateway": g.isEnablePaymentGateway,
            "isEnableFeeRefundApproval": g.isEnableFeeRefundApproval,

            // Add Payment Gateway Settings
            "paymentGatewayBoth": g.paymentGatewayBoth || false,
            "paymentGatewayWeb": g.paymentGatewayWeb || false,
            "paymentGatewayMobile": g.paymentGatewayMobile || false,

            "concessionSettings": {
                'fee': g.fee
            },
            "blockStudent": {
                "isBlockStudent": g.isBlockStudent,
                "dueDays": g.dueDays,
                "comments": g.comments,
            },
            "reportCards": {
                'feeamount': g.feeamount,
                "minAmount": g.minAmount,
                "isEnabled": g.isEnabled,
            },
            "feeReceiptSettings": {
                "noOfReceiptsPrinted": g.noOfReceiptsPrinted,
                "noOfParentCopies": g.noOfParentCopies,
                "noOfAdminCopies": g.noOfAdminCopies,
                "isReceiptsBasedOnFeeType": g.isReceiptsBasedOnFeeType
            },
            "partialPayment": g.partialPayment,
            "adjustmentRules": g.adjustmentRules,
            "admissionOverrideProrata": g.admissionOverrideProrata,
            "categoryPairs": this.state.categoryPairs,
            "branchAdjustmentRules": g.branchAdjustmentRules,
            "branchOverrideProrata": g.branchOverrideProrata,
        }

        let flag = true
        if (!payload?.receiptPrefix) {
            flag = false
            this.setState({
                isLoading: false
            })
            this.toast?.show({ severity: 'error', summary: 'Error', detail: 'Please enter the Receipt Prefix', life: 3000 });
        }

        payload.academicYear = AcademicYear
        let url = `${baseUrlAdmin}/feeSettings`;

        if (this.state.generalSettings._id) {
            payload._id = g._id
        } else {
            delete payload._id
        }

        if (flag) {
            this.service.post(url, payload, true).then(data => {
                if (data?.status && data?.res?.status === 200) {
                    this.setState({
                        isLoading: false
                    })
                    this.toast?.show({
                        severity: 'info',
                        summary: 'Success',
                        detail: data?.res?.message || 'Settings updated successfully'
                        , life: 3000
                    });
                    this.getGeneralSettings()
                } else {
                    this.setState({
                        isLoading: false
                    })

                    // Check for payment gateway not enabled error
                    const responseStatus = data?.res?.status || data?.status;
                    const responseMessage = data?.res?.message || data?.message || '';

                    if (responseStatus === 403 && responseMessage.toLowerCase().includes('payment gateway')) {

                        // Revert payment gateway checkboxes to false
                        this.setState(prevState => ({
                            generalSettings: {
                                ...prevState.generalSettings,
                                paymentGatewayBoth: false,
                                paymentGatewayWeb: false,
                                paymentGatewayMobile: false
                            }
                        }));

                        this.toast?.show({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'In superadmin payment setup has not enabled.',
                            life: 5000
                        });
                    } else {
                        this.toast?.show({
                            severity: 'error',
                            summary: 'Error',
                            detail: responseMessage || 'An error occurred while updating the settings',
                            life: 3000
                        });
                    }
                }
            }).catch(error => {
                console.error('Error in onSubmitGeneralSettings:', error);
                this.setState({
                    isLoading: false
                });
                this.toast?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'An unexpected error occurred',
                    life: 3000
                });
            });
        }

    }

    addCategoryPair = () => {

        const { categoryPairs } = this.state;
        const isValid = categoryPairs.every(pair => pair.from && pair.to);
        if (!isValid) {
            this.toast?.show({ severity: 'error', summary: 'Error', detail: 'Please fill all fields before adding a new pair.', life: 3000 });
            return;
        }
        this.setState(prevState => ({
            categoryPairs: [...prevState.categoryPairs, { from: '', to: '', midTermTransfersAllowed: false }]
        }));
    }

    removeCategoryPair = (index) => {
        this.setState(prevState => ({
            categoryPairs: prevState.categoryPairs.filter((_, i) => i !== index)
        }));
    }

    handleCategoryChange = (value, type, index) => {
        const { categoryPairs } = this.state;
        /* Check type and compare with the value for below if conditions*/
        if (type === 'from') {
            if (categoryPairs.some((pair, i) => i !== index && pair.from === value && pair.to === categoryPairs[index].to)) {
                this.toast?.show({ severity: 'error', summary: 'Error', detail: `The combination of already exists.`, life: 3000 });
                return;
            }
        } else if (type === 'to') {
            if (categoryPairs.some((pair, i) => i !== index && pair.to === value && pair.from === categoryPairs[index].from)) {
                this.toast?.show({ severity: 'error', summary: 'Error', detail: `The combination of already exists.`, life: 3000 });
                return;
            }
        }

        if (type === 'to' && !categoryPairs[index].from) {
            this.toast?.show({ severity: 'error', summary: 'Error', detail: 'Please select a "From" value before selecting a "To" value.', life: 3000 });
            return;
        }

        if (type === 'from' || type === 'to') {
            const otherType = type === 'from' ? 'to' : 'from';
            const otherValue = categoryPairs[index][otherType];
            if (value === otherValue) {
                this.toast?.show({ severity: 'error', summary: 'Error', detail: `The ${type} value cannot be the same as the ${otherType} value.`, life: 3000 });
                return;
            }
        }

        this.setState(prevState => ({
            categoryPairs: prevState.categoryPairs.map((pair, i) => {
                if (i === index) {
                    return { ...pair, [type]: value };
                }
                return pair;
            })
        }));
    }

    render() {
        const { generalSettings, formValidations } = this.state
        return (
            <>
                <div className="settings-content-container mb-5 mt-5 mr-5 ml-5">
                    <div className="grid " style={{ padding: '0px 20px 0px 0px' }} >
                        <div className="sm:col-6 lg:col-3 md:col-6">
                            <label className='label mb-1'>Fee Certificate Authorized Signatory<span className='ma-required'>*</span></label>
                            <div className="mt-2">
                                <ClassetDropdown
                                    id='authorizedSignatory'
                                    className="text-xl"
                                    height="48px"
                                    width="368px"
                                    options={principalNames}
                                    value={generalSettings.authorizedSignatory}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'authorizedSignatory', this, generalSettingsformFields, generalSettings, formValidations, 'generalSettings', formValidations) }}
                                    placeholder={(
                                        <div>
                                            <span className='text-xl'>Select Principal Name</span>
                                        </div>
                                    )}
                                />
                            </div>
                            {formValidations && !formValidations.fields['authorizedSignatory'].isValid && <p className="p-error">{formValidations.fields['authorizedSignatory'].errorMsg}</p>}
                        </div>


                    </div>

                    <div className="grid " style={{ padding: '0px 20px 0px 0px' }} >
                        <div className="sm:col-6 lg:col-3 md:col-6">
                            <label className='label mb-1'>GST</label>
                            <div className="mt-2">
                                <ClassetInputText
                                    id='gstPer'
                                    className=""
                                    height="48px"
                                    width="368px"
                                    placeholder="Enter GST"
                                    value={generalSettings?.gstPer}
                                    maxLength={2}
                                    onChange={(e) => { onTextChange(e.target.value, 'gstPer', this, generalSettingsformFields, generalSettings, formValidations, 'generalSettings', formValidations) }}
                                />

                                {formValidations && !formValidations.fields['receiptPrefix'].isValid && <p className="p-error">{formValidations.fields['receiptPrefix'].errorMsg}</p>}

                            </div>

                        </div>

                    </div>

                    <div className="grid" style={{ padding: '0px 20px 0px 0px' }} >
                        <div className="sm:col-6 lg:col-3 md:col-6">
                            <label className='label mb-1'>Receipt Prefix<span className='ma-required'>*</span></label>
                            <div className="mt-2">
                                <ClassetInputText
                                    id='receiptPrefix'
                                    className=""
                                    height="48px"
                                    width="368px"
                                    placeholder="Enter receipt prefix"
                                    value={generalSettings?.receiptPrefix?.toUpperCase()}
                                    maxLength={2}
                                    onChange={(e) => { onTextChange(e.target.value, 'receiptPrefix', this, generalSettingsformFields, generalSettings, formValidations, 'generalSettings', formValidations) }}
                                />

                                {formValidations && !formValidations.fields['receiptPrefix'].isValid && <p className="p-error">{formValidations.fields['receiptPrefix'].errorMsg}</p>}

                            </div>

                        </div>
                    </div>

                    <div className="grid my-6 " style={{ padding: '20px' }}>
                        <div className='flex my-4'>
                            <div className=" flex  ">
                                <InputSwitch className="" id='isLockFeeCollection'
                                    checked={generalSettings?.isLockFeeCollection}
                                    onChange={(e) => { onToggleChange(e.value, 'isLockFeeCollection', this, generalSettingsformFields, generalSettings, formValidations, 'generalSettings', formValidations) }}
                                />
                                <div className="flex flex-column lg:ml-3 ">
                                    <label className="generalSettings-label1" htmlFor='isLockFeeCollection'>Lock Fee Collection </label>
                                    <p className="generalSettings-label2">Any user would not be able to do any fee cancellation and parents won't be able to do online payment</p>
                                </div>
                            </div>

                            <div className=" flex  ">
                                <InputSwitch className=""
                                    id='isPrintTransportDetails'
                                    checked={generalSettings?.isPrintTransportDetails}
                                    onChange={(e) => { onToggleChange(e.value, 'isPrintTransportDetails', this, generalSettingsformFields, generalSettings, formValidations, 'generalSettings', formValidations) }}

                                />
                                <div className="flex flex-column lg:ml-3 ">
                                    <label className="generalSettings-label1" htmlFor='isPrintTransportDetails'>Print Transport Details</label>
                                    <p className="generalSettings-label2">It allows schools to include the transport detals of the student in the fee receipt</p>
                                </div>
                            </div>
                        </div>
                        <div className='flex my-4'>
                            <div className=" flex  ">
                                <InputSwitch className=""
                                    id="isTransportdetailsinFeeReceipt"
                                    checked={generalSettings?.isTransportdetailsinFeeReceipt}
                                    onChange={(e) => { onToggleChange(e.value, 'isTransportdetailsinFeeReceipt', this, generalSettingsformFields, generalSettings, formValidations, 'generalSettings', formValidations) }}
                                />
                                <div className="flex flex-column lg:ml-3 ">
                                    <label className="generalSettings-label1" htmlFor='isLockFeeCollection'>Transport Details of the student in the fee receipt </label>
                                    <p className="generalSettings-label2">When is is enables system will not allow user to pay selected dues are still pending </p>
                                </div>
                            </div>

                            <div className=" flex  ">
                                <InputSwitch className=""
                                    id='isStudentLoginFeeCollection'
                                    checked={generalSettings?.isStudentLoginFeeCollection}
                                    onChange={(e) => { onToggleChange(e.value, 'isStudentLoginFeeCollection', this, generalSettingsformFields, generalSettings, formValidations, 'generalSettings', formValidations) }}

                                />
                                <div className="flex flex-column lg:ml-3 ">
                                    <label className="generalSettings-label1" htmlFor='isStudentLoginFeeCollection'>Student Login Fee Collection </label>
                                    <p className="generalSettings-label2">payment can be done from student login as well</p>
                                </div>
                            </div>
                        </div>
                        <div className='flex my-4'>
                            <div className=" flex  ">
                                <InputSwitch className=""
                                    id='isPartialPayment'
                                    checked={generalSettings?.isPartialPayment}
                                    onChange={(e) => { onToggleChange(e.value, 'isPartialPayment', this, generalSettingsformFields, generalSettings, formValidations, 'generalSettings', formValidations) }}
                                />
                                <div className="flex flex-column lg:ml-3">
                                    <label className="generalSettings-label1" htmlFor='isPartialPayment'>Partial Payment-Parent Login </label>
                                    <p className="generalSettings-label2">Allow Partial Payment in Parent Login</p>
                                </div>
                            </div>

                            <div className=" flex  ">
                                <InputSwitch className=""
                                    id='isEnablePaymentGateway'
                                    checked={generalSettings?.isEnablePaymentGateway}
                                    onChange={(e) => { onToggleChange(e.target.value, 'isEnablePaymentGateway', this, generalSettingsformFields, generalSettings, formValidations, 'generalSettings', formValidations) }}
                                />
                                <div className="flex flex-column lg:ml-3 ">
                                    <label className="generalSettings-label1" htmlFor='isEnablePaymentGateway'>Enable Payment Gateway - parents  </label>
                                    <p className="generalSettings-label2">Parents will be able to pay fees online using Mobile/Web</p>
                                </div>
                            </div>
                        </div>
                        <div className='flex my-4'>
                            <div className=" flex  ">
                                <InputSwitch className=""
                                    id='isEnableFeeRefundApproval'
                                    checked={generalSettings.isEnableFeeRefundApproval}
                                    onChange={(e) => { onChoiceChange(e.value, 'isEnableFeeRefundApproval', this, generalSettingsformFields, generalSettings, formValidations, 'generalSettings', formValidations) }}
                                />
                                <div className="flex flex-column lg:ml-3 ">
                                    <label className="generalSettings-label1" htmlFor='isEnableFeeRefundApproval'>Enable Fee Refund Approval</label>
                                    <p className="generalSettings-label2">Admin's Approval will be needed for Refunding Fees</p>
                                </div>
                            </div>
                            <div className=" flex  ">
                                <InputSwitch className=""
                                    id='partialPayment'
                                    checked={generalSettings?.partialPayment}
                                    onChange={(e) => { onChoiceChange(e.value, 'partialPayment', this, generalSettingsformFields, generalSettings, formValidations, 'generalSettings', formValidations) }}
                                />
                                <div className="flex flex-column lg:ml-3 ">
                                    <label className="generalSettings-label1" htmlFor='isEnableFeeRefundApproval'>Enable Partial Fee Payment</label>
                                    <p className="generalSettings-label2">Admin's Approval will be needed for Partial Fee Payment</p>
                                </div>
                            </div>

                        </div>
                    </div>


                    <div className="generalsetting-card cursor-pointer" style={{ paddingLeft: '20px' }}>
                        <div className="flex flex-column ">
                            <h3 className='genaralsettings-cardhead  ' >Concession Settings</h3>
                            <div className='flex mt-5 '>
                                <div className="flex  align-items-center mr-2 ml-8 mt-2 " style={{ padding: '20px' }}>
                                    <RadioButton inputId="onTotalFees"
                                        name="fee"
                                        id='onTotalFees'
                                        value='onTotalFees'
                                        checked={generalSettings?.fee === 'onTotalFees'}

                                        onChange={(e) => {
                                            onChoiceChange(e.value, 'fee', this, generalSettingsformFields, generalSettings, formValidations, 'generalSettings', formValidations)
                                        }}
                                    />
                                    <label htmlFor="onTotalFees" className="ml-3 generalSettings-label1">On Total Fees</label>

                                </div>


                                <div className="flex align-items-center ml-4">
                                    <RadioButton inputId="onRemainingFees" name="fee"
                                        id='onRemainingFees'
                                        value='onRemainingFees'
                                        checked={generalSettings?.fee === 'onRemainingFees'}

                                        onChange={(e) => {
                                            onChoiceChange(e.value, 'fee', this, generalSettingsformFields, generalSettings, formValidations, 'generalSettings', formValidations)
                                        }}
                                    />
                                    <label htmlFor="onRemainingFees" className="ml-3 generalSettings-label1">On Remaining Fees</label>
                                </div>
                            </div>
                            <p className="ml-4 mt-3 generalsettings-cardtext">Select The Method of Calculator for concession amount when multiple concessions are assigned to the student</p>
                        </div>
                    </div>
                    <div className='generalsetting-card  cursor-pointer' style={{ paddingLeft: '30px' }}>
                        <div className="flex flex-column ">
                            <h3 className='genaralsettings-cardhead mb-5'>Fee Due Block Student</h3>
                            {/* <div className="flex mt-2 "> */}
                            <div className="flex row mt-5 " style={{ paddingTop: '20px', paddingBottom: '20px' }}>
                                <InputSwitch
                                    checked={generalSettings?.isBlockStudent}
                                    onChange={(e) => { onToggleChange(e.value, 'isBlockStudent', this, generalSettingsformFields, generalSettings, formValidations, 'generalSettings', formValidations) }}
                                    id='isBlockStudent' />
                                <div className="flex flex-column ml-3">
                                    <h3 className='generalSettings-label1'>Enable Block Student</h3>
                                    <p className="ml-0 mt-0 generalsettings-cardtext">Enable this setting if you want to block acounts of students who haven't paid the fees</p>
                                </div>
                                {/* {formValidations && !formValidations.fields['isBlockStudent'].isValid && <p className="p-error">{formValidations.fields['isBlockStudent'].errorMsg}</p>} */}



                            </div>
                            {/* </div> */}

                            <div className="grid">
                                <div className="sm:col-12 lg:col-6">
                                    <label className='ml-0 generalSettings-label1'>Due Days<span className='ma-required'>*</span></label>
                                    <div className="mt-2">
                                        <ClassetInputText
                                            id='dueDays'
                                            // icon={<CodeLinkIcon height={22} />}
                                            className=""
                                            height="48px"
                                            width="368px"
                                            placeholder="Due Days"
                                            value={generalSettings?.dueDays}
                                            onChange={(e) => { onTextChange(e.value, 'dueDays', this, generalSettingsformFields, generalSettings, formValidations, 'generalSettings', formValidations) }}
                                        />
                                        {/* {formValidations && !formValidations.fields['dueDays'].isValid && <p className="p-error">{formValidations.fields['dueDays'].errorMsg}</p>} */}


                                    </div>
                                </div>
                                <div className=" sm:col-12 lg:col-6">
                                    <label className='ml-0 generalSettings-label1'>Comment<span className='ma-required'>*</span></label>
                                    <div className="mt-2">
                                        <ClassetInputText
                                            id='comments'
                                            // icon={<CodeLinkIcon height={22} />}
                                            className=""
                                            height="48px"
                                            width="368px"
                                            placeholder="Comment/Records"
                                            value={generalSettings?.blockStudent?.comments}
                                            onChange={(e) => { onTextChange(e.value, 'comments', this, generalSettingsformFields, generalSettings, formValidations, 'generalSettings', formValidations) }}
                                        />
                                        {/* {formValidations && !formValidations.fields['comments'].isValid && <p className="p-error">{formValidations.fields['comments'].errorMsg}</p>} */}



                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className=" generalsetting-card cursor-pointer " style={{ paddingLeft: '30px' }}>
                        <div className="flex flex-column">
                            <h3 className="genaralsettings-cardhead">Record Cards Fee Defaulters</h3>
                            <div className="mt-2">
                                <div className='flex mt-5 '>
                                    <div className="flex  align-items-center mr-2 ml-8 " style={{ padding: '20px' }}>
                                        <RadioButton inputId="isFeeAmount" name='feeamount'
                                            id='isFeeAmount'
                                            value='isFeeAmount'
                                            checked={generalSettings?.feeamount === 'isFeeAmount'}
                                            onChange={(e) => {
                                                onChoiceChange(e.value, 'feeamount', this, generalSettingsformFields, generalSettings, formValidations, 'generalSettings', formValidations)

                                            }}

                                        />
                                        <label htmlFor="isFeeAmount" className="ml-3 generalSettings-label1">Fee Amount</label>
                                    </div>
                                    <div className="flex align-items-center">
                                        <RadioButton inputId="isFeePercentage" name='feeamount'
                                            id='isFeePercentage'
                                            value='isFeePercentage'
                                            checked={generalSettings?.feeamount === 'isFeePercentage'}
                                            onChange={(e) => {
                                                onChoiceChange(e.value, 'feeamount', this, generalSettingsformFields, generalSettings, formValidations, 'generalSettings', formValidations)
                                            }}

                                        />
                                        <label htmlFor="isFeePercentage" className="ml-3 generalSettings-label1">Fee Percentage on Total fee</label>
                                    </div>
                                </div>
                            </div>
                            <div className="grid mt-2">
                                <div className="lg:col-3 sm:col-12">
                                    <label className='ml-0 generalSettings-label1'>Minimum Amount <span className='ma-required'>*</span></label>
                                    <div className="mt-2">
                                        <ClassetInputText
                                            id='minAmount'
                                            // icon={<CodeLinkIcon height={22} />}
                                            className=""
                                            height="48px"
                                            width="368px"
                                            placeholder="Minimum Amount Over Due"
                                            value={generalSettings?.minAmount}
                                            onChange={(e) => { onTextChange(e.target.value, 'minAmount', this, generalSettingsformFields, generalSettings, formValidations, 'generalSettings', formValidations) }}

                                        />
                                        {/* {formValidations && !formValidations.fields['minAmount'].isValid && <p className="p-error">{formValidations.fields['minAmount'].errorMsg}</p>} */}

                                    </div>

                                </div>


                                <div className="lg:col-3 col-4 mt-5 sm:col-12 ">
                                    <div className="flex mt-3">
                                        <InputSwitch inputId="isEnabled"
                                            id='isEnabled'
                                            className="mr-2"
                                            checked={generalSettings?.isEnabled}
                                            onChange={(e) => { onToggleChange(e.target.value, 'isEnabled', this, generalSettingsformFields, generalSettings, formValidations, 'generalSettings', formValidations) }}

                                        />
                                        {/* {formValidations && !formValidations.fields['isEnabled'].isValid && <p className="p-error">{formValidations.fields['isEnabled'].errorMsg}</p>} */}


                                        <label className='generalSettings-label1 ml-1'>Enable </label>
                                    </div>
                                </div>

                                {/* </div> */}
                            </div>

                        </div>
                    </div>
                    <div className="generalsetting-card  cursor-pointer " style={{ paddingLeft: '30px' }}>
                        <div className="flex flex-column">
                            <h3 className="genaralsettings-cardhead">
                                Fee Receipt Settings
                            </h3>
                            <div className="flex -ml-5  mt-4" style={{ padding: '16px' }}>

                                <div className="lg:col-4 sm:col-4">
                                    <label className='generalSettings-label1'>Total Fee Receipt Printed<span className='ma-required'>*</span></label>
                                    <div className="mt-2">
                                        <ClassetDropdown
                                            id='noOfReceiptsPrinted'
                                            className="text-xl"
                                            height="48px"
                                            width="368px"
                                            options={sampleOptions}
                                            value={generalSettings?.noOfReceiptsPrinted}
                                            onChange={(e) => { onDropDownChange(e.target.value, 'noOfReceiptsPrinted', this, generalSettingsformFields, generalSettings, formValidations, 'generalSettings', formValidations) }}

                                            placeholder={(
                                                <div>
                                                    <span className='text-xl'>Total Fee Receipt</span>
                                                </div>
                                            )}
                                        />
                                    </div>
                                </div>
                                <div className="lg:col-4 sm:col-4">
                                    <label className='generalSettings-label1'>Total Parent Copies<span className='ma-required'>*</span></label>
                                    <div className="mt-2">
                                        <ClassetDropdown
                                            id='noOfParentCopies'
                                            className="text-xl"
                                            height="48px"
                                            width="368px"
                                            options={sampleOptions}
                                            value={generalSettings?.noOfParentCopies}
                                            onChange={(e) => { onDropDownChange(e.target.value, 'noOfParentCopies', this, generalSettingsformFields, generalSettings, formValidations, 'generalSettings', formValidations) }}
                                            placeholder={(
                                                <div>
                                                    <span className='text-xl'>Total Parent Copies</span>
                                                </div>
                                            )}
                                        />
                                    </div>
                                </div>
                                <div className="lg:col-4 sm:col-4">
                                    <label className='generalSettings-label1'>Total Admin Copies<span className='ma-required'>*</span></label>
                                    <div className="mt-2">
                                        <ClassetDropdown
                                            id='noOfAdminCopies'
                                            className="text-xl"
                                            height="48px"
                                            width="368px"
                                            options={sampleOptions}
                                            value={generalSettings?.noOfAdminCopies}
                                            onChange={(e) => { onDropDownChange(e.target.value, 'noOfAdminCopies', this, generalSettingsformFields, generalSettings, formValidations, 'generalSettings', formValidations) }}

                                            placeholder={(
                                                <div>
                                                    <span className='text-xl'>Total Admin Copies</span>
                                                </div>
                                            )}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="grid lg:col-6 sm:col-6 mb-4" style={{ padding: '16px' }}>
                                <div className="flex">

                                    <InputSwitch className="mt-1"
                                        id='isReceiptsBasedOnFeeType'
                                        checked={generalSettings?.isReceiptsBasedOnFeeType}
                                        onChange={(e) => { onToggleChange(e.target.value, 'isReceiptsBasedOnFeeType', this, generalSettingsformFields, generalSettings, formValidations, 'generalSettings', formValidations) }}
                                    />
                                    <div className="flex flex-column">
                                        <h3 htmlFor="ontotalfee" className="ml-3 generalSettings-label1">Recipts Bsed on Fee Types</h3>
                                        <p className="generalSettings-label2 ml-3">Will Generate Fee Receipt Based on fee Type collection Preference
                                            but parent will have single recipt and will override above requirements
                                        </p>
                                    </div>
                                </div>


                            </div>



                        </div>

                    </div>

                    <div className="generalsetting-card  cursor-pointer " style={{ paddingLeft: '30px' }}>
                        <div className="flex flex-column">
                            <h4 className="genaralsettings-cardhead">
                                Admission Category Change
                            </h4>
                            <div className="flex -ml-5  mt-4" style={{ padding: '16px' }}>
                                <div className="lg:col-4 sm:col-4">
                                    <label className='generalSettings-label1'>Adjustment Rule<span className='ma-required'>*</span></label>
                                    <div className="mt-2">
                                        <ClassetDropdown
                                            id='adjustmentRules'
                                            className="text-xl"
                                            height="48px"
                                            width="368px"
                                            options={adjustmentRules}
                                            value={generalSettings?.adjustmentRules}
                                            onChange={(e) => { onDropDownChange(e.target.value, 'adjustmentRules', this, generalSettingsformFields, generalSettings, formValidations, 'generalSettings', formValidations) }}

                                            placeholder={(
                                                <div>
                                                    <span className='text-xl'>Select the time frame</span>
                                                </div>
                                            )}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="grid lg:col-6 sm:col-6 " style={{ padding: '16px' }}>
                                <div className="flex">
                                    <InputSwitch className="mt-1"
                                        id='admissionOverrideProrata'
                                        checked={generalSettings?.admissionOverrideProrata}
                                        onChange={(e) => { onToggleChange(e.target.value, 'admissionOverrideProrata', this, generalSettingsformFields, generalSettings, formValidations, 'generalSettings', formValidations) }}
                                    />
                                    <div className="flex flex-column">
                                        <h3 htmlFor="ontotalfee" className="ml-3 generalSettings-label1">Override Pro-rata</h3>
                                        <p className="generalSettings-label2 ml-3">If activated pro-rata assigned in fee types will be overridden
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-column w-full">
                                {this.state.categoryPairs?.map((pair, index) => (
                                    <div key={index} className="flex align-items-center mb-4">
                                        <div className="lg:col-3 sm:col-3">
                                            <label className='generalSettings-label1'>Category Change From<span className='ma-required'>*</span></label>
                                            <div className="mt-2">
                                                <ClassetDropdown
                                                    id={`admiCategoryChangeFrom${index}`}
                                                    className="text-xl"
                                                    height="48px"
                                                    width="300px"
                                                    optionLabel='label'
                                                    optionValue='value'
                                                    options={this.state.admissionCategories}
                                                    value={pair.from}
                                                    onChange={(e) => this.handleCategoryChange(e.target.value, 'from', index)}
                                                    placeholder={(
                                                        <div>
                                                            <span className='text-xl'>Select Category</span>
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        <div className="lg:col-3 sm:col-3">
                                            <label className='generalSettings-label1'>Category Change To<span className='ma-required'>*</span></label>
                                            <div className="mt-2">
                                                <ClassetDropdown
                                                    id={`admiCategoryChangeTo${index}`}
                                                    className="text-xl"
                                                    height="48px"
                                                    optionLabel='label'
                                                    optionValue='value'
                                                    width="300px"
                                                    options={this.state.admissionCategories}
                                                    value={pair.to}
                                                    onChange={(e) => this.handleCategoryChange(e.target.value, 'to', index)}
                                                    placeholder={(
                                                        <div>
                                                            <span className='text-xl'>Select Category</span>
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        <div className="lg:col-5 sm:col-5 mt-4">
                                            <label className='generalSettings-label1'>Mid Term Transfers Allowed<span className='ma-required'>*</span></label>
                                            <div >
                                                <div className="flex align-items-center">
                                                    <InputSwitch
                                                        id={`midTermTransfersAllowed${index}`}
                                                        checked={pair?.midTermTransfersAllowed || false}
                                                        onChange={(e) => this.handleCategoryChange(e.value, 'midTermTransfersAllowed', index)}
                                                    />
                                                    <span className="ml-5 mt-4 generalSettings-label2">
                                                        {pair?.midTermTransfersAllowed ? "Allowed" : "Not Allowed"}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex align-items-center gap-2">
                                            {(index === this.state.categoryPairs.length - 1 &&
                                                pair.from && pair.to) ? (
                                                <Button
                                                    icon="pi pi-plus"
                                                    className="mt-5 ml-2"
                                                    onClick={this.addCategoryPair}
                                                />
                                            ) : null}
                                            {(pair.from &&
                                                this.state.categoryPairs.length >= 1) ? (
                                                <Button
                                                    icon="pi pi-times"
                                                    className="mt-5"
                                                    onClick={() => this.removeCategoryPair(index)}
                                                />
                                            ) : null}
                                        </div>
                                    </div>
                                ))}

                            </div>
                        </div>

                    </div>
                    <div className="generalsetting-card  cursor-pointer " style={{ paddingLeft: '30px' }}>
                        <div className="flex flex-column">
                            <h4 className="genaralsettings-cardhead">
                                Student Branch Transfer
                            </h4>
                            <div className="flex -ml-5  mt-4" style={{ padding: '16px' }}>
                                <div className="lg:col-4 sm:col-4">
                                    <label className='generalSettings-label1'>Adjustment Rule<span className='ma-required'>*</span></label>
                                    <div className="mt-2">
                                        <ClassetDropdown
                                            id='branchAdjustmentRules'
                                            className="text-xl"
                                            height="48px"
                                            width="368px"
                                            options={adjustmentRules}
                                            value={generalSettings?.branchAdjustmentRules}
                                            onChange={(e) => { onDropDownChange(e.target.value, 'branchAdjustmentRules', this, generalSettingsformFields, generalSettings, formValidations, 'generalSettings', formValidations) }}

                                            placeholder={(
                                                <div>
                                                    <span className='text-xl'>Select the time frame</span>
                                                </div>
                                            )}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="grid lg:col-6 sm:col-6 " style={{ padding: '16px' }}>
                                <div className="flex">
                                    <InputSwitch className="mt-1"
                                        id='branchOverrideProrata'
                                        checked={generalSettings?.branchOverrideProrata}
                                        onChange={(e) => { onToggleChange(e.target.value, 'branchOverrideProrata', this, generalSettingsformFields, generalSettings, formValidations, 'generalSettings', formValidations) }}
                                    />
                                    <div className="flex flex-column">
                                        <h3 htmlFor="ontotalfee" className="ml-3 generalSettings-label1">Override Pro-rata</h3>
                                        <p className="generalSettings-label2 ml-3">If activated pro-rata assigned in fee types will be overridden
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    {/* CASHFREE */}
                    <div className="generalsetting-card cursor-pointer" style={{ paddingLeft: '30px' }}>
                        <div className="flex flex-column">
                            <h4 className="genaralsettings-cardhead">
                                Enable Payment Gateway
                            </h4>

                            <div className="mt-4" style={{ padding: '16px' }}>
                                <div className="flex gap-3" style={{ padding: '16px' }}>
                                    {/* Both Option */}
                                    <div className="flex align-items-center">
                                        <input
                                            type="checkbox"
                                            id="paymentGatewayBoth"
                                            checked={generalSettings?.paymentGatewayBoth || false}
                                            onChange={(e) => {
                                                // Handle manually without form helper
                                                const checked = e.target.checked;
                                                this.setState(prevState => ({
                                                    generalSettings: {
                                                        ...prevState.generalSettings,
                                                        paymentGatewayBoth: checked,
                                                        paymentGatewayWeb: checked,
                                                        paymentGatewayMobile: checked
                                                    }
                                                }));
                                            }}
                                            style={{
                                                width: '16px',
                                                height: '16px',
                                                accentColor: '#007bff',
                                                marginRight: '8px'
                                            }}
                                        />
                                        <label htmlFor="paymentGatewayBoth" className="generalSettings-label1 font-semibold">
                                            Both
                                        </label>
                                    </div>

                                    {/* Web Application Option */}
                                    <div className="flex align-items-center">
                                        <input
                                            type="checkbox"
                                            id="paymentGatewayWeb"
                                            checked={generalSettings?.paymentGatewayWeb || false}
                                            onChange={(e) => {
                                                const checked = e.target.checked;
                                                this.setState(prevState => {
                                                    const newSettings = {
                                                        ...prevState.generalSettings,
                                                        paymentGatewayWeb: checked
                                                    };

                                                    // Auto-update "Both" checkbox logic
                                                    if (!checked) {
                                                        newSettings.paymentGatewayBoth = false;
                                                    } else if (checked && prevState.generalSettings?.paymentGatewayMobile) {
                                                        newSettings.paymentGatewayBoth = true;
                                                    }

                                                    return {
                                                        generalSettings: newSettings
                                                    };
                                                });
                                            }}
                                            style={{
                                                width: '16px',
                                                height: '16px',
                                                accentColor: '#007bff',
                                                marginRight: '8px'
                                            }}
                                        />
                                        <label htmlFor="paymentGatewayWeb" className="generalSettings-label1">
                                            Web Application
                                        </label>
                                    </div>

                                    {/* Mobile Application Option */}
                                    <div className="flex align-items-center">
                                        <input
                                            type="checkbox"
                                            id="paymentGatewayMobile"
                                            checked={generalSettings?.paymentGatewayMobile || false}
                                            onChange={(e) => {
                                                const checked = e.target.checked;
                                                this.setState(prevState => {
                                                    const newSettings = {
                                                        ...prevState.generalSettings,
                                                        paymentGatewayMobile: checked
                                                    };

                                                    // Auto-update "Both" checkbox logic
                                                    if (!checked) {
                                                        newSettings.paymentGatewayBoth = false;
                                                    } else if (checked && prevState.generalSettings?.paymentGatewayWeb) {
                                                        newSettings.paymentGatewayBoth = true;
                                                    }

                                                    return {
                                                        generalSettings: newSettings
                                                    };
                                                });
                                            }}
                                            style={{
                                                width: '16px',
                                                height: '16px',
                                                accentColor: '#007bff',
                                                marginRight: '8px'
                                            }}
                                        />
                                        <label htmlFor="paymentGatewayMobile" className="generalSettings-label1">
                                            Mobile Application
                                        </label>
                                    </div>
                                </div>

                                <p className="generalSettings-label2 mt-3">
                                    Select the modes of using the payment gateway in the platform
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="button-wrapper">
                        <Authorizer permId={PERMISSIONS.GENERAL_SETTINGS_UPDATE} >
                            <Button className='submitButton'
                                onClick={this.onSubmitGeneralSettings}
                            >
                                <p className='submitButtonText'>Save</p>
                            </Button>
                        </Authorizer>
                        <Authorizer permId={PERMISSIONS.GENERAL_SETTINGS_UPDATE} >
                            <Button
                                className="cancelButtonn"

                                onClick={this.onHideCreateFeeCategoryDialog}>
                                <p className='cancelButtonnText'>Cancel</p>

                            </Button>
                        </Authorizer>

                    </div>

                </div>

                <Toast ref={(el) => this.toast = el} position="bottom-right" />

                {this.state.isLoading && <LoadingComponent />}
            </>
        )
    }
}
export default GeneralSettings